/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "overview",
	init: init,
	triggers: triggers,

	_who: null,

	sayViewing: sayViewing,
	loadHealthIndicators: loadHealthIndicators
});

function init() {
	this._who = null;
	this.loadHealthIndicators();
}

function triggers() {
	return {
		"view": view,
		"reset": reset,
	};
}

function view(data) {
	var who = data.who;

	this._who = who;
	this.loadHealthIndicators();
	this.sayViewing();
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who
	});
	this.dispatch("usermetrics:trigger:track", "view myhealth overview", {
		who: this._who
	});
}

function reset(){
	this.emit("activity:trigger:reset");
	this.emit("bloodsugar:trigger:reset");
	this.emit("bloodpressure:trigger:reset");
	this.emit("weight:trigger:reset");
	this.emit("bloodoxygen:trigger:reset");
	this.emit("bodytemperature:trigger:reset");
	this.emit("usermetrics:trigger:track", "close myhealth overview");
}

function loadHealthIndicators() {
	this.emit("activity:trigger:load");
	this.emit("bloodsugar:trigger:load");
	this.emit("bloodpressure:trigger:load");
	this.emit("weight:trigger:load");
	this.emit("bloodoxygen:trigger:load");
	this.emit("bodytemperature:trigger:load");
}

